import { render, staticRenderFns } from "./Lgx202100746110369792.vue?vue&type=template&id=ca54adc8&scoped=true&"
import script from "./Lgx202100746110369792.vue?vue&type=script&lang=js&"
export * from "./Lgx202100746110369792.vue?vue&type=script&lang=js&"
import style0 from "./Lgx202100746110369792.vue?vue&type=style&index=0&id=ca54adc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca54adc8",
  null
  
)

export default component.exports